import { MembershipStatusTranslationsService } from 'src/app/shared/translations';
import { DateObject } from '../reusables/date-object';
import { Status } from '../reusables/status';

/**
 * Blueprint for the address object.
 */
export class CrmMembership {
  public id: number;
  public '@id': string;
  public customer: string;
  public membershipNumber: string;
  public comment: string;
  public section: string;
  public joinDate: DateObject;
  public status: Status;

  public statuses: Array<any> = [
    {
      value: 'member',
      status: this.translations.i18nMemberStatus,
      class: 'esf-tag--success'
    },
    {
      value: 'terminated',
      status: this.translations.i18nTerminatedStatus,
      class: 'esf-tag--alert'
    },
    {
      value: 'locked',
      status: this.translations.i18nLockedStatus,
      class: 'esf-tag--alert'
    },
  ];

  public constructor(data: any, private translations: MembershipStatusTranslationsService) {
    this['@id'] = data['@id'];
    this.id = data.id;
    this.customer = data.customer;
    this.membershipNumber = data.membershipNumber;
    this.comment = data.comment;
    this.joinDate = data.joinDate ? new DateObject(data.joinDate, 'dd.MM.yyyy') : null;
    this.status = new Status(this.getFullStatus(data.status));
  }

  /**
   * Retrieves the status
   */
  public getFullStatus(status: string): any {
    const fullStatus = this.statuses.find(possibleStatuses => status === possibleStatuses.value);
    return fullStatus ? fullStatus : {};
  }
}
